import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { postApiDataWithToken } from "views/utils/CallApi";
import * as mb from "views/common/MessageBox";
import { CtxAuth } from "views/utils/Contexts";
import Calendar, { Detail } from 'react-calendar';
import { getTimeRange,string8ToDate } from "views/utils/CommonFunc";

interface IFOrderHistory {
    orderNo: string,
    orderName: string,
    scheduledDate: string,
    scheduleNo: number,
    patternId: string,
    frameNo: number,
    address: string
}
interface IFPostOrderHistory {
    scheduled_date: string,
    schedule_no: number,
    pattern_id: string,
    frame_no: number,
    ikkatu_flg: number
}
interface IFScheduledHistoryMonth {
    fullDay: string,
    scheduledHistoryDay: IFScheduledHistoryDay[]
}
interface IFScheduledHistoryDay {
    frameNo: number,
    scheduleStartTime: string,
    scheduleEndTime: string,
    status: number,
    patternId: string,
    scheduleNo: number,
    orderHistory: IFOrderHistory[]
}
interface IFSelectedHistory {
    fullDay: string,
    scheduledHistory: IFScheduledHistoryDay
}
interface IFDate {
    date: string
}

export function OrderCalendar(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [orderHistory, setOrderHistory] = useState<IFOrderHistory[]>();
    const [scheduledHistoryMonth, setScheduledHistoryMonth] = useState<IFScheduledHistoryMonth[]>();
    const [selectedMonth, setSelectedMonth] = useState({text:""});
    const [selectedCurrentHistory, setSelectedCurrentHistory] = useState<IFSelectedHistory>();
    const [selectedHistory, setSelectedHistory] = useState<IFSelectedHistory[]>();
    sessionStorage.setItem('order_url', window.location.href);

    useEffect(function(){

        //選択月の日リストを取得
        let currentDay = new Date();
        if(selectedMonth.text.length === 6){
            currentDay = string8ToDate(selectedMonth.text + "01");
        }
        let lastDate = new Date(currentDay.getFullYear(),currentDay.getMonth()+1,0);
        let selectedDateList:IFDate[] = [];
        for (let i = 1; i <= lastDate.getDate(); i++){
            selectedDateList.push({"date": lastDate.getFullYear() + ('00' + (lastDate.getMonth()+1)).slice(-2) + ('00' + i).slice(-2)});
        }

        //注文確定情報取得
        let odHistory:IFOrderHistory[] = [];
        postApiDataWithToken('/management/orders/schedule/month',
            {"month_list": selectedDateList},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status) {
                    case 200:
                        for (let order of res.data.order_result) {
                            odHistory.push({
                                orderNo:order.order_no,
                                orderName:order.order_name,
                                scheduledDate:order.scheduled_date,
                                scheduleNo:order.schedule_no,
                                patternId:order.pattern_id,
                                frameNo:order.frame_no,
                                address:order.address
                            });
                        }
                        setOrderHistory(odHistory);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );

        //該当月のスケジュール枠と空き情報を取得
        let scHistoryMonth:IFScheduledHistoryMonth[] = [];
        let scHistoryDay:IFScheduledHistoryDay[] = [];
        let orHistory:IFOrderHistory[] = [];
        postApiDataWithToken(`/management/schedules/schedule/month`,
            {"month_list": selectedDateList},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        if(res.data.month_list.length !== 0){
                            for (let dateList of res.data.month_list){
                                scHistoryDay = [];
                                for (let frameList of dateList.calandar_list){
                                    orHistory = [];
                                    scHistoryDay.push({
                                        frameNo:frameList.frame_no,
                                        scheduleStartTime:frameList.schedule_start_time,
                                        scheduleEndTime:frameList.schedule_end_time,
                                        status:frameList.status,
                                        patternId:dateList.pattern_id,
                                        scheduleNo:dateList.schedule_no,
                                        orderHistory: orHistory
                                    });
                                }
                                scHistoryMonth.push({fullDay:dateList.date,scheduledHistoryDay:scHistoryDay});
                            }
                        }
                        setScheduledHistoryMonth(scHistoryMonth);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMonth]);

    function getFrameOrderList(frameList:IFScheduledHistoryDay, fullDay:String):IFOrderHistory[]{
        let result:IFOrderHistory[] = [];
        if(orderHistory===undefined){return result;}
        for (let orderList of orderHistory){
            if(orderList.scheduledDate===fullDay && 
                orderList.frameNo===frameList.frameNo){
                    result.push(orderList);
            }
        }
        return result;
    }

    function getTileContent(date:Date, view:Detail) : JSX.Element {
        if(scheduledHistoryMonth===undefined){return <></>;}
        for (let dateList of scheduledHistoryMonth){
            let fullDay = date.getFullYear()+('00'+(date.getMonth()+1)).slice(-2)+('00'+date.getDate()).slice(-2);
            if(dateList.fullDay===fullDay){
                let buffer = [];
                //枠情報に埋め込む
                for (let frameList of dateList.scheduledHistoryDay){
                    let selectedDateCss = ""
                    if(selectedHistory && selectedHistoryIndexOf({fullDay:fullDay,scheduledHistory:frameList},selectedHistory)>=0){
                        selectedDateCss = " is-selected"
                    }
                    switch(frameList.status){
                        case 0:
                            frameList.orderHistory = getFrameOrderList(frameList, dateList.fullDay);
                            buffer.push(
                                <div className={"reserved-item is-vacant" + selectedDateCss} onClick={function(){clickDay(frameList, dateList.fullDay)}}>
                                    <span className="icon icon-status-circle"></span> <span className="reserved-item-time">{getTimeRange(frameList.scheduleStartTime,frameList.scheduleEndTime)}</span><span className="reserved-item-count">（{frameList.orderHistory.length}件）</span>
                                </div>
                            );
                            break;
                        case 1:
                            frameList.orderHistory = getFrameOrderList(frameList, dateList.fullDay);
                            buffer.push(
                                <div className={"reserved-item is-full" + selectedDateCss} onClick={function(){clickDay(frameList, dateList.fullDay)}}>
                                    <span className="icon icon-status-cross"></span> <span className="reserved-item-time">{getTimeRange(frameList.scheduleStartTime,frameList.scheduleEndTime)}</span><span className="reserved-item-count">（{frameList.orderHistory.length}件）</span>
                                </div>
                            );
                            break;
                        default:
                    }
                }
                return (
                    <>
                        {buffer}
                    </>
                )
            }
        }
        return <></>;
    }
    
    // 日付クリック処理
    function clickDay(frameList:IFScheduledHistoryDay, fullDay:string){
        let sHistory:IFSelectedHistory[] = [];
        sHistory.push({fullDay:fullDay,scheduledHistory:frameList});
        if (selectedHistory!==undefined){
            //既に選択されていたら取り出す：選択されていなかったら入れる
            let index = selectedHistoryIndexOf(sHistory[0],selectedHistory);
            if (index>=0){
                selectedHistory.splice(index,1);
            }else{
                selectedHistory.push(sHistory[0]);
            }
            setSelectedHistory(selectedHistory);
        } else {
            //最初の1こめ
            setSelectedHistory(sHistory);
        }
        setSelectedCurrentHistory({fullDay:fullDay,scheduledHistory:frameList});
    }

    //選択されている日時が選択リストに含まれているか
    function selectedHistoryIndexOf(search:IFSelectedHistory, target:IFSelectedHistory[]){
        let index = -1;
        for (let i=0; i < target.length; i++){
            if (target[i].fullDay===search.fullDay && 
                target[i].scheduledHistory.frameNo===search.scheduledHistory.frameNo &&
                target[i].scheduledHistory.patternId===search.scheduledHistory.patternId &&
                target[i].scheduledHistory.scheduleNo===search.scheduledHistory.scheduleNo){
                    index = i;
                }
        }
        return index;
    }
    
    // 前へ次へ月クリック処理
    function onChangeDate(date: Date){
        setSelectedMonth({text:date.getFullYear().toString()+('00'+(date.getMonth()+1).toString()).slice(-2)});
    }

    //締め切る/受け付ける
    function onClickCloseFrame(bool: Boolean){
        let sHistory:IFSelectedHistory[] = [];
        let postOrderHistory:IFPostOrderHistory[] = [];
        if(selectedHistory===undefined || selectedHistory.length === 0){
            return;
        }
        for(let history of selectedHistory){
            postOrderHistory.push({
                    "scheduled_date": history.fullDay,
                    "schedule_no": history.scheduledHistory.scheduleNo,
                    "pattern_id": history.scheduledHistory.patternId,
                    "frame_no": history.scheduledHistory.frameNo,
                    "ikkatu_flg": Number(bool)
                });
        }
        postApiDataWithToken(`/management/orders/confirm`,
            {
                "schedule_list": postOrderHistory
            },
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        bool ? setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"選択した日時を受け付け中に変更しました。"})
                            : setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"選択した日時を締め切りました。"});
                        //選択状態の解除
                        setSelectedHistory(sHistory);
                        //カレンダーの再描画
                        setSelectedMonth({text:selectedMonth.text});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"選択した日時の変更に失敗しました。"});
                }
            }
        );
    }

    return (
        <AdminFrame>
            <div className="contents">
            <mb.MessageBox args={msgArgs}/>
                <div className="control-horizon control-between reserved-calendar-header">
                    <h2 className="settings-title-h2">予約カレンダー</h2>
                    <div className="control-horizon reserved-calendar-header-btn">
                        <button className="btn-secondary btn-icon-left" onClick={function(){onClickCloseFrame(false)}}><span className="icon material-icons-round md-18">lock</span>選択した日時の予約を締め切る</button>
                        <button className="btn-secondary btn-icon-left" onClick={function(){onClickCloseFrame(true)}}><span className="icon material-icons-round md-18">lock_open</span>選択した日時の予約を受け付ける</button>
                    </div>
                </div>
                <div className="control-horizon control-between reserved-calendar-body">
                    <div className="reserved-calendar-left">
                        <Calendar 
                            locale="ja-JP" 
                            onActiveStartDateChange={function(props){onChangeDate(props.activeStartDate)}}
                            formatDay={function(locale, date){return date.getDate().toString()}}
                            tileContent={function({ activeStartDate, date, view }): JSX.Element { return getTileContent(date, view)}}
                            prevLabel={<span className="material-icons-round">navigate_before</span>} 
                            nextLabel={<span className="material-icons-round">navigate_next</span>} 
                            prev2Label={null} next2Label={null} 
                            className={"reserved-calendar"}
                            minDetail={"month"}
                            maxDetail={"month"}
                            view={"month"}
                        />
                    </div>
                    <div className="reserved-calendar-right">
                        <div className="reserved-calendar-order">
                            <div className="reserved-calendar-order-date">{selectedCurrentHistory?.fullDay.slice(0,4)}年{selectedCurrentHistory?.fullDay.slice(4,6)}月{selectedCurrentHistory?.fullDay.slice(-2)}日</div>
                            <div className="reserved-calendar-order-time">{getTimeRange(selectedCurrentHistory===undefined ? "00:00:00" : selectedCurrentHistory?.scheduledHistory.scheduleStartTime,selectedCurrentHistory===undefined ? "00:00:00" : selectedCurrentHistory?.scheduledHistory.scheduleEndTime)}</div>
                            <div className="reserved-calendar-order-count">{selectedCurrentHistory?.scheduledHistory.orderHistory.length}件</div>
                            <ul>
                            {selectedCurrentHistory?.scheduledHistory.orderHistory.map(function(val, idx){
                                return(
                                    <li key={val.orderNo} className="reserved-calendar-order-item"><a href={"./order/edit?orderNo=" + val.orderNo}>{val.orderName + "(" + val.address + ")"}</a></li>
                                )
                            })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </AdminFrame>
    )
}